<button [disabled]="isHidden" class="button _secondary backButton" [class.expanded]="expanded">
    <i *ngIf="showBackIcon" class="fas fa-chevron-left backButton-icon"></i>
    <a-button-text [labelKey]="labelKey" [loading]="loading"></a-button-text>
</button>
